function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.205353 16H4.72321C5.75102 16 6.98214 14.8053 6.98214 13.8667V0H2.46428C1.43647 0 0.205353 1.19467 0.205353 3.2V16Z",
  fill: "#047AB1"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.76924 10.816C1.9019 10.8162 1.03884 10.7013 0.205353 10.4747V9.30134C0.852141 9.67905 1.59145 9.89218 2.35134 9.92001C3.22102 9.92001 3.70669 9.34401 3.70669 8.55468V5.33334H5.85267V8.55468C5.85267 9.81334 5.15241 10.816 2.76924 10.816Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.1116 16H12.6295C13.6573 16 14.8884 14.8053 14.8884 13.8667V0H10.3705C9.34272 0 8.1116 1.19467 8.1116 3.2V16Z",
  fill: "#D42D06"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.1116 6.07999C8.76669 5.48266 9.89616 5.10933 11.7259 5.19466C12.7198 5.23733 13.7589 5.51466 13.7589 5.51466V6.69866C13.1646 6.35918 12.4965 6.15131 11.805 6.09066C10.4157 5.97333 9.56861 6.70933 9.56861 7.99999C9.56861 9.29066 10.4157 10.0267 11.805 9.91999C12.497 9.85393 13.1646 9.64255 13.7589 9.30133V10.4747C13.7589 10.4747 12.7198 10.7627 11.7259 10.8053C9.89616 10.8907 8.76669 10.5173 8.1116 9.91999V6.07999Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0179 16H20.5357C21.5635 16 22.7946 14.8053 22.7946 13.8667V0H18.2768C17.249 0 16.0179 1.19467 16.0179 3.2V16Z",
  fill: "#67B637"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6652 9.28001C21.6652 10.1333 20.9649 10.6667 20.0275 10.6667H16.0179V5.33334H19.666L19.9258 5.34401C20.7503 5.38668 21.3602 5.84534 21.3602 6.63468C21.3602 7.25334 20.9423 7.78668 20.1856 7.91468V7.94668C21.0214 8.00001 21.6652 8.50134 21.6652 9.28001ZM18.785 6.17601C18.7364 6.16914 18.6874 6.16558 18.6382 6.16534H17.2829V7.50934H18.785C19.0674 7.44534 19.3046 7.20001 19.3046 6.83734C19.3046 6.47468 19.0674 6.22934 18.785 6.17601ZM18.9545 8.35201C18.8947 8.34315 18.8342 8.33958 18.7737 8.34134H17.2829V9.80268H18.7737L18.9545 9.78134C19.2368 9.71734 19.474 9.44001 19.474 9.06668C19.474 8.69334 19.2481 8.42668 18.9545 8.35201Z",
  fill: "white"
});
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.2b5a70ad6fbc72be66a1b853b51fcd84.svg";
export { ForwardRef as ReactComponent };